module.exports = __webpack_public_path__ + "img/goyoga-manager-referencer-activite.e981003.jpeg";